// extracted by mini-css-extract-plugin
module.exports = {"profile-container":"profile_profile-container__3a9X8","post-list":"profile_post-list__2Cjbt"};